var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmiled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 82,
    viewBox: "0 0 350 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5096 61.9475C67.5096 54.4387 63.4591 50.0085 53.1076 49.4078C41.3128 48.8464 29.5775 47.3906 18.0026 45.0527C4.95071 42.4997 0 34.8408 0 25.9053V24.1783C0 15.0175 4.95071 10.8126 18.0026 13.2905C34.4559 16.7223 51.2286 18.3837 68.0347 18.2463V21.3249C51.2303 21.4252 34.4615 19.7642 18.0026 16.3691C7.50107 14.4168 3.67553 18.1712 3.67553 25.0793V26.8814C3.67553 34.3902 7.7261 40.0969 18.0026 41.899C29.5961 44.2776 41.3595 45.7338 53.1826 46.2541C66.2345 47.0801 71.1852 52.9369 71.1852 61.7973V66.6029C71.1852 75.5384 66.2345 81.6205 53.1826 80.9447C35.8304 80.3407 18.6095 77.6944 1.87527 73.0605V70.1321C18.6062 74.7928 35.8273 77.4643 53.1826 78.0914C63.3841 78.7672 67.5096 73.8114 67.5096 66.678V61.9475Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.849 73.4359V15.7684C152.947 40.998 145.071 53.3124 129.243 78.3167L126.093 78.6921C110.266 57.292 102.315 46.4794 86.4874 23.953V81.5454H83.1119V18.1712H86.7124C103.14 41.5236 111.316 52.5615 127.518 75.0879C143.946 49.3327 152.122 36.2674 168.624 10.0617L172.525 9.53613V72.9103L168.849 73.4359Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.477 71.0331V7.50875L190.227 7.05823V70.5075L186.477 71.0331Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.329 68.7054V5.25613L208.005 4.8056V64.8759C226.239 62.3808 244.592 60.8519 262.988 60.2956V63.224C243.351 64.0059 223.771 65.8356 204.329 68.7054V68.7054Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.489 63.4493V-1.3205e-05C293.634 -0.670028 313.785 1.12025 333.498 5.33123V8.40983C315.111 4.49274 296.335 2.70392 277.54 3.07859V28.3832C295.688 28.009 313.823 29.6204 331.622 33.1888V36.1924C313.829 32.587 295.69 30.9752 277.54 31.3867V60.4457C296.535 60.0247 315.515 61.8138 334.098 65.777V68.7805C314.201 64.446 293.836 62.6546 273.489 63.4493V63.4493Z",
    fill: "#964E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.499 71.4086V60.0703L350 61.1966V72.5349L345.499 71.4086Z",
    fill: "#964E7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 81.6206,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiled);
export default __webpack_public_path__ + "static/media/smiled.d67fd836ac3a59c7ae25ee8d9701f93d.svg";
export { ForwardRef as ReactComponent };